import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators';

import {ApiService} from '../../../shared/api';
import {UserService} from '../../../shared/user';
import {FormOutcome, Task} from '../../../shared/workflow/workflow-v2.interface';
import {CommunicationsService} from '../../shared/communications.service';

@Injectable()
export class TasksService {
  public taskIdLastViewed$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(private communicationsService: CommunicationsService,
              private userService: UserService,
              private apiService: ApiService) {
  }

  public updateTaskReadStatus(taskId: string, read: boolean): Observable<void> {
    return this.userService.getUser().pipe(
      switchMap((user) => {
        const body = {
          read
        };
        return this.apiService.post(`/workflowable/tasks/${taskId}/read`, body).pipe(
          switchMap(() => this.communicationsService.updateRecentInboxItemById(taskId, read)
          ));
      })
    );
  }

  public updateTaskRequestVariable(task: Task, formOutcome: FormOutcome): Observable<FormOutcome> {
    return this.apiService.post(`/workflowable/tasks/${task.id}/variables`, formOutcome.updatedRequest).pipe(
      tap(() => task.variables.map(variable => variable.name === 'request' ? formOutcome.updatedRequest : variable)),
      map(() => formOutcome)
    );
  }
}
